import { useState } from "react";
import { useSignOutUser } from "../services/authService";
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import { ConfirmationDialog } from "@shared/components";

export const Logout = () => {
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const { mutateAsync: signOut } = useSignOutUser();

  const handleLogoutClick = async () => {
    await signOut();
    setLogoutDialogOpen(false);
  };

  return (
    <>
      <List>
        <ListItem disablePadding>
          <ListItemButton
            onClick={() => setLogoutDialogOpen(true)}
            sx={{
              minHeight: 48,
              justifyContent: "center",
              px: 2.5,
              "&:hover": {
                backgroundColor: "rgba(25, 118, 210, 0.08)",
                "& .MuiListItemIcon-root": {
                  color: "primary.main",
                },
                "& .MuiListItemText-primary": {
                  color: "primary.main",
                },
              },
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: 3,
                justifyContent: "center",
              }}
            >
              <PowerSettingsNewIcon />
            </ListItemIcon>
            <ListItemText primary="Logout" />
          </ListItemButton>
        </ListItem>
      </List>

      <ConfirmationDialog
        open={logoutDialogOpen}
        onClose={() => setLogoutDialogOpen(false)}
        onConfirm={handleLogoutClick}
        title="Logout"
        message="Are you sure you want to logout?"
        confirmText="Logout"
        cancelText="Cancel"
        confirmColor="primary"
      />
    </>
  );
};

export default Logout;
